var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { withStyles } from "@material-ui/core";
import { useLinked } from "@type-r/react";
import * as React from 'react';
import Select, { components } from "react-select";
import AsyncSelect from 'react-select/async';
export var SelectMulti = withStyles({})(function (_a) {
    var classes = _a.classes, options = _a.options, $selected = _a.$selected, onMenuClosed = _a.onMenuClosed;
    var $selection = useLinked([]);
    var _b = React.useState(""), inputValue = _b[0], setInputValue = _b[1];
    var filteredOptions = React.useMemo(function () {
        if (!inputValue) {
            return options.slice(0, 100);
        }
        var inputValueLower = inputValue.toLowerCase();
        return options.filter(function (x) { return x.toLowerCase().indexOf(inputValueLower) >= 0; }).slice(0, 100);
    }, [inputValue]);
    var selectChangeHandler = function (event, action) {
        if (action.action === 'select-option' || action.action === 'deselect-option') {
            $selection.set(event);
            $selected.set(event.map(function (ev) { return ev.value; }));
        }
    };
    return (React.createElement(Select, { components: { Option: Option, ClearIndicator: ClearIndicator }, filterOption: function () { return true; }, hideSelectedOptions: false, isMulti: true, styles: customStyles, className: classes.selectionBox, onInputChange: function (value) { return setInputValue(value); }, options: filteredOptions.map(function (opt) { return { label: opt, value: opt }; }), placeholder: 'Select', value: $selection && $selection.value, onChange: function (event, action) { return selectChangeHandler(event, action); }, onMenuClose: onMenuClosed, closeMenuOnSelect: false }));
});
export var SelectMultiEx = withStyles({})(function (_a) {
    var classes = _a.classes, options = _a.options, selected = _a.selected, _b = _a.label, label = _b === void 0 ? function (x) { return x.label; } : _b, placeholder = _a.placeholder, autocomplete = _a.autocomplete;
    var selectOptions = React.useMemo(function () { return options.map(function (opt) { return ({ label: label(opt), value: opt.id }); }); }, [options['_changeToken']]);
    var selectChangeHandler = function (event, action) {
        if (action.action === 'select-option' || action.action === 'deselect-option') {
            selected.set(event.map(function (ev) { return options.get(ev.value); }));
        }
        if (action.action === 'clear') {
            selected.reset();
        }
    };
    var getPrependedSelectedOptions = function (options) {
        return selected.map(function (x) { return ({ label: label(x), value: x.id }); }).concat(options.filter(function (x) { return !selected.some(function (y) { return y.id === x.value; }); }).slice(0, 50));
    };
    var loadOptions = function (inputValue) {
        return new Promise(function (resolve) {
            var trimmedValue = inputValue.trim();
            if (!trimmedValue) {
                resolve(getPrependedSelectedOptions(selectOptions));
            }
            else {
                var regex_1 = new RegExp("^(" + trimmedValue + ")", 'i');
                resolve(getPrependedSelectedOptions(selectOptions.filter(function (x) { return regex_1.test(x.label); })));
            }
        });
    };
    var commonProps = {
        components: { Option: Option, ClearIndicator: autocomplete ? getAutocompleteClearIndicator(selectOptions.length) : ClearIndicator },
        isMulti: true,
        styles: customStyles,
        className: classes.selectionBox,
        hideSelectedOptions: false,
        placeholder: placeholder || 'Select',
        value: selected.map(function (x) { return ({ label: label(x), value: x.id }); }),
        onChange: function (event, action) { return selectChangeHandler(event, action); },
        closeMenuOnSelect: false,
    };
    return autocomplete
        ? (React.createElement(AsyncSelect, __assign({}, commonProps, { defaultOptions: getPrependedSelectedOptions(selectOptions), loadOptions: loadOptions }))) : (React.createElement(Select, __assign({}, commonProps, { options: selectOptions })));
});
var customStyles = {
    multiValue: function (provided) { return ({
        display: 'none'
    }); },
    valueContainer: function (provided) { return (__assign({}, provided, { width: '200px', height: '40px', overflowX: 'hidden', overflowY: 'auto' })); },
    indicatorSeparator: function () { return ({
        display: 'none'
    }); },
    clearIndicator: function (provided) { return (__assign({}, provided, { padding: '0px' })); },
    dropdownIndicator: function (provided) { return (__assign({}, provided, { padding: '5px' })); },
    option: function (provided) { return ({
        backgroundColor: 'red',
        fontSize: 10
    }); },
};
var Option = function (props) {
    return (React.createElement("div", null,
        React.createElement(components.Option, __assign({}, props),
            React.createElement("div", { style: { float: 'left' } },
                React.createElement("input", { style: { margin: '5px' }, type: "checkbox", checked: props.isSelected, onChange: function () { return null; } }),
                React.createElement("label", { style: { margin: '5px', width: '180px', textAlign: 'left' } }, props.label)))));
};
var ClearIndicator = function (props) {
    var selectedCount = props.selectProps.value["length"];
    return (React.createElement("div", null,
        React.createElement(components.ClearIndicator, __assign({}, props),
            React.createElement("div", { style: { marginLeft: '5px', float: 'left', color: 'green' } },
                "Clear ",
                props.selectProps.placeholder,
                React.createElement("span", null,
                    " ",
                    selectedCount,
                    "/",
                    props.totalOptions || props.options.length)))));
};
var getAutocompleteClearIndicator = function (totalOptions) {
    return function (props) { return (React.createElement(ClearIndicator, __assign({ totalOptions: totalOptions }, props))); };
};
//# sourceMappingURL=selecti-multi.js.map